import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);

/**
 * Исправляет схлопывание последнего padding'а внутри overflow:scroll flex--контейнера
 */
export var ScrollPaddingFix = function ScrollPaddingFix() {
  return /*#__PURE__*/React.createElement("div", {
    className: cn('fix'),
    "data-t-id": "ScrollContainerV3-extra"
  });
};